export default "__VITE_ASSET__NeiznB5j__"